module.exports = __webpack_public_path__ + "img/18-avatar male.55f7bc7f.png";